import BlogLoadMoreContainer from "../../../../components/pages/blog/blogPage/BlogLoadMore";

const BlogLoadMore = () => {
  return <BlogLoadMoreContainer />;
};

export default BlogLoadMore;
